module.exports = "https://static.cdns.space/qurangrowth-temp/img/m1.fbab4e0d.webp";